module.exports = require('./lib/uslug');


//////////////////
// WEBPACK FOOTER
// ./~/uslug/index.js
// module id = 429
// module chunks = 1